import { render, staticRenderFns } from "./StatisticTile.vue?vue&type=template&id=22adb0c7&scoped=true&lang=pug&"
import script from "./StatisticTile.vue?vue&type=script&lang=js&"
export * from "./StatisticTile.vue?vue&type=script&lang=js&"
import style0 from "./StatisticTile.vue?vue&type=style&index=0&id=22adb0c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22adb0c7",
  null
  
)

export default component.exports